// src/utils/theme.js
// LarimerGO brand colors and constants

export const colors = {
  red: '#ae3030',
  redDark: '#a51828',
  navy: '#182B45',
  navyLight: '#0d2d52',
  white: '#ffffff',
  lightGray: '#f5f5f5',
};

export const APP_NAME = 'VoterGO';
export const APP_TAGLINE = 'Larimer County Republican Voter Hub';
export const ELECTION_YEAR = '2026';
export const PRIMARY_DATE = 'June 30, 2026';
export const GENERAL_DATE = 'November 3, 2026';
export const COUNTY_NAME = 'Larimer County';

export const EXTERNAL_LINKS = {
  coSOS: 'https://www.sos.state.co.us/voter/pages/pub/home.xhtml',
  ballotTrax: 'https://ballottrax.coloradosos.gov/voter/?_gl=1*qvfqh7*_ga*MTQ5ODE0NDM4OC4xNzc5NDg5NTUw*_ga_JDK6PLVHDW*czE3ODA1NDYwMDAkbzEzJGcwJHQxNzgwNTQ2MDAwJGo2MCRsMCRoMA..',
  sampleBallot: 'https://myballot.coloradosos.gov/app/home?qa=1&preview=0&cb=112',
  larimerClerk: 'https://www.larimer.gov/clerk/elections/where-to-vote',
  mailBallot: 'https://www.sos.state.co.us/voter/pages/pub/home.xhtml',
  voterFAQ: 'https://www.coloradosos.gov/pubs/elections/FAQs/FAQsMain.html?_gl=1*b6hwgf*_ga*MTQ5ODE0NDM4OC4xNzc5NDg5NTUw*_ga_JDK6PLVHDW*czE3Nzk1MjA1MjgkbzYkZzEkdDE3Nzk1MjA1NjAkajI4JGwwJGgw',
  tracer: 'https://tracer.sos.colorado.gov/publicsite/homepage.aspx',
  candidateList: 'https://www.sos.state.co.us/pubs/elections/vote/primaryCandidates.html',
};
